function ThirdPillarNewFundsSelection(initialActiveFunds, availableFunds, labels) {
  const render = Handlebars.compile($('#thirdpillar-funds-template').html())
  let activeFundsByIsin = {}

  this.init = function () {
    activeFundsByIsin = initialActiveFunds.reduce((r, activeFund) => {
      r[activeFund.fund.isin] = {isin: activeFund.fund.isin, name: activeFund.fund.name, percentage: activeFund.percentage}
      return r
    }, {})
    draw()
  }

  this.getActiveFundsList = function() {
    return Object.values(activeFundsByIsin)
  }

  function draw() {
    const params = {activeFunds: activeFundsByIsin, availableFunds: availableFunds.filter(f => !activeFundsByIsin[f.isin])}
    const html = render($.extend(params, labels))
    const container = $('#third-pillar-active-funds-container')
    container.html(html);

    container.find('#new-fund').on('change', addFund)
    container.find('.delete').on('click', deleteFund)
    container.find('[name="percentage"]').on('change', onPercentageChanged)
  }

  function addFund() {
    const option = $(this).find('option:selected')
    const fund = {isin: option.val(), name: option.text(), percentage: 100, units: 0, justAdded: true}
    if (fund.isin) {
      activeFundsByIsin[fund.isin] = fund
      const justAddedFunds = Object.values(activeFundsByIsin).filter(f => f.justAdded)
      const percentage = Math.round(100 / justAddedFunds.length)
      const firstPercentage = percentage + (100 - percentage * justAddedFunds.length)
      justAddedFunds.forEach((f, i) => f.percentage = i ? percentage : firstPercentage)
      draw()
    }
  }

  function onPercentageChanged(event) {
    const select = $(event.target)
    const fundIsin = select.data('fund')
    activeFundsByIsin[fundIsin].percentage = Number(select.val())

    const col = select.closest('.col-md-2')
    col.toggleClass('has-danger', !isValidPercentage(select.val()))
  }

  function deleteFund(event) {
    delete activeFundsByIsin[event.currentTarget.dataset.fund]
    draw()
  }

  function isValidPercentage(value) {
    return !isNaN(value) && value >= 0 && value <= 100
  }
}
